export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_10.197bff02.jpg";